import * as React from 'react';
import { Form } from 'formik';
import { Theme, css } from '@emotion/react';

const dialogFormRoot = ({ spacing }: Theme) => css`
  display: flex;
  max-height: calc(100% - ${spacing(8)}px);
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
`;

/**
 * @deprecated Fine to use for Tock internal tools only. Please use `@tocktix/pantry` UI components for any new JCE admin tools.
 */
const DialogForm: React.FunctionComponent<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <Form css={dialogFormRoot}>{children}</Form>;
};

export default DialogForm;
